module.exports = __webpack_public_path__ + "img/sustain-development-br.e0f14d9f.png";